import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const ExchangeStepMessage = ({ article }: { article: ArticleWithRelations }) => {
  if (
    article.step?.step === 'exchange' &&
    article.step.config.startExchange?.enabled &&
    !article.exchangeStartedAt
  ) {
    return (
      <BaseMessage
        title={
          <Trans id="article.step-message.unstarted-exchange.title">
            Pending start of exchange
          </Trans>
        }
        message={
          <Trans id="article.step-message.unstarted-exchange.message">
            The exchange has not been started yet.
          </Trans>
        }
        article={article}
      />
    );
  }

  return (
    <BaseMessage
      title={
        <Trans id="article.step-message.exchange">The exchange of the item is being handled.</Trans>
      }
      message={null}
      article={article}
    />
  );
};
